import { render, staticRenderFns } from "./DataDump.vue?vue&type=template&id=53cc3964&scoped=true&"
import script from "./DataDump.vue?vue&type=script&lang=js&"
export * from "./DataDump.vue?vue&type=script&lang=js&"
import style0 from "./DataDump.vue?vue&type=style&index=0&id=53cc3964&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53cc3964",
  null
  
)

export default component.exports